<template>
  <RModal
    ref="modal"
    title="Update address"
    ok-btn-label="Update Address"
    @hide="$emit('input', false)"
    @cancel="$event()"
    @ok="save"
  >
    <Grid gtc="1fr 1fr" gap="0 var(--r-space-xxl)" class="q-mt-md" style="width: 900px">
      <div class="text-body-3 text-secondary-2 q-pb-md">Main address</div>
      <div class="text-body-3 text-secondary-2 q-pb-md">Bank address</div>
      <AddressFields ref="mainAddress" :initial-address="mainAddress" />
      <AddressFields ref="bankAddress" :initial-address="bankAddress" />
    </Grid>
  </RModal>
</template>

<script>
// Libraries
// Components
import RModal from '@/ui/RModal'
import AddressFields from '@/reusable/address-fields/AddressFields'

export default {
  components: {
    RModal,
    AddressFields
  },

  inject: ['updateProvider'],

  props: {
    value: Boolean,
    mainAddress: {
      type: Object,
      required: true
    },
    bankAddress: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      formData: {
        addresses: []
      },
      addressToCopy: null
    }
  },

  watch: {
    value(newVal) {
      if (newVal) this.$refs.modal.show()
      else this.$emit('input', false)
    }
  },

  methods: {
    save(hide, setLoading) {
      setLoading(true)

      this.updateProvider({
        addresses: [this.$refs.mainAddress.getPayload(), this.$refs.bankAddress.getPayload()]
      })
        .then(hide)
        .finally(() => setLoading(false))
    }
  }
}
</script>
